import React from 'react';

export default function CheckboxIcon(props) {
  return (
    <img src="/assets/files/questions/checkbox.svg" alt="checkbox" {...props} />
  );
}
